import React from 'react';

// تنبيهات المحرّك — للإدارة فقط، تُخفى عن الجهة في الوضع المنشور.
export default function AlertsPanel({ alerts }) {
  if (!alerts?.length) return null;

  const style = (level) => level === 'warning'
    ? { color: 'var(--warning)', bg: 'var(--warning-light)', icon: '⚠' }
    : { color: 'var(--info)', bg: 'var(--info-light)', icon: 'ℹ' };

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-title" style={{ marginBottom: 10 }}>تنبيهات التحقّق ({alerts.length})</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {alerts.map((a, i) => {
          const s = style(a.level);
          return (
            <div key={i} style={{ display: 'flex', gap: 10, padding: '8px 10px', borderRadius: 6, background: s.bg, borderInlineStart: `3px solid ${s.color}` }}>
              <span style={{ color: s.color, fontWeight: 700 }}>{s.icon}</span>
              <div style={{ fontSize: 13 }}>
                {a.message_ar}
                <span style={{ fontSize: 10, color: 'var(--text-muted)', marginInlineStart: 6 }}>[{a.code}]</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
